import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import messages from './messages'
import { FormattedMessage, useIntl } from 'react-intl'
import Box from './Box'
import cn from 'classnames'
import Terms from './Terms'
import { insertFBScript } from '../../utils'
import { setSessionItem } from '../../storeManager'
import { trackRegistrationMethod, trackErrorMessage } from '../../analytics'
import { getFacebookUserDetails, getUserCountry } from '../../auth'
import StepHeading from './StepHeading'
import { useSelector } from 'react-redux'
import { selectCoupon } from 'js/store/pricingSlice'
import { pushToDataLayer } from 'js/pages/LandingPages/utils'

function SignUpPickAccountMethod({ onBack, onComplete }) {
  const { formatMessage } = useIntl()
  const [facebookLoading, setFacebookLoading] = useState(false)
  const [facebookError, setFacebookError] = useState(null)
  const [showFacebookLogin, setShowFacebookLogin] = useState(
    !navigator.userAgent.match(/instagram|bytedance|snapchat/i),
  )
  const coupon = useSelector(selectCoupon)
  const buttonStyles = 'my-12 uppercase w-full rounded-8 px-24 py-16'

  useEffect(() => {
    if (coupon === 'low-cost-test-purchase') {
      setShowFacebookLogin(true)
    }
  }, [coupon])

  const handleEmailOption = () => {
    onComplete({ accountMethod: 'email' })
    pushToDataLayer({
      event: 'signup_form',
      section: 'registration_method',
      label: 'email',
      success: 1,
      error_message: undefined,
    })
  }

  const getUserDetails = () => {
    setSessionItem('registration-method', 'Facebook')
    trackRegistrationMethod({ method: 'Facebook' })

    getFacebookUserDetails()
      .then((response) => {
        getUserCountry().then((country) => {
          onComplete({
            email: response.email,
            firstName: response.first_name,
            country,
            oauth_service: 'facebook',
            oauth_token: response.token,
          })
        })
      })
      .catch((err) => {
        trackErrorMessage({
          type:
            err && err.exists
              ? 'Email already connected'
              : 'Facebook connection error',
          category: 'Signup',
        })
        setFacebookError(
          err && err.exists
            ? formatMessage(messages.errorFacebookAlreadyConnected)
            : formatMessage(messages.errorFacebookWentWrong),
        )
      })
      .catch(() => {
        trackErrorMessage({
          type: 'Facebook connection error',
          category: 'Signup',
        })
        setFacebookError(formatMessage(messages.errorFacebookWentWrong))
      })
      .finally(() => setFacebookLoading(false))
  }

  const connectFacebook = () => {
    setFacebookLoading(true)
    insertFBScript()
      .then(() => getUserDetails())
      .catch(() =>
        setFacebookError(formatMessage(messages.errorFacebookWentWrong)),
      )
    pushToDataLayer({
      event: 'signup_form',
      section: 'registration_method',
      label: 'facebook',
      success: facebookError === undefined ? '1' : '0',
      error_message: facebookError, //if an error occurs when the user selects registration method and proceeds to the next step send error messages, if no error send undefined
    })
  }

  return (
    <div className="o-width-limiter flex w-full flex-col">
      <StepHeading>
        <FormattedMessage {...messages.accountflow_method_heading} />
      </StepHeading>
      <Box onBack={onBack}>
        <div className="flex h-full flex-col justify-between">
          {facebookLoading && <img src={require('media/spinner.gif')} alt="" />}
          {facebookError && (
            <p className="c-signup-flow__error">{facebookError}</p>
          )}
          <div className="flex flex-col items-center">
            {showFacebookLogin && (
              <button
                data-uid="continue_with_facebook_button"
                className={cn('bg-[#3f65bb] text-white', buttonStyles)}
                onClick={connectFacebook}
              >
                <span>
                  <span className="c-button__icon c-button__icon--fb" />
                  <FormattedMessage {...messages.continueWithFacebook} />
                </span>
              </button>
            )}
            <button
              data-uid="continue_with_email_button"
              type="button"
              onClick={() => handleEmailOption()}
              className={cn('bg-BgMain  text-TypeSub', buttonStyles)}
            >
              <span>
                <FormattedMessage {...messages.continueWithEmail} />
              </span>
            </button>
          </div>
          <Terms />
        </div>
      </Box>
    </div>
  )
}

SignUpPickAccountMethod.propTypes = {
  onBack: PropTypes.func,
  onComplete: PropTypes.func.isRequired,
}

export default SignUpPickAccountMethod
